import { useRef, useEffect } from 'react';

const useVideoStream = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      })
      .catch((error) => {
        console.error('Error accessing the camera', error);
      });

    const currentRef = videoRef.current;
    return () => {
      if (currentRef && currentRef.srcObject) {
        currentRef.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  return videoRef;
};

export default useVideoStream;
